module.exports = __webpack_public_path__ + "img/222.000b7c04.png";